import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Career Opportunities
  getCareers: async () => {
    const response = await axios.get(`${API}/careers`);
    return response.data;
  },

  applyForCareer: async ({ jobId, name, email, resume, contribution }) => {
    const response = await axios.post(`${API}/careers/apply`, {
      jobId,
      name,
      email,
      resume,
      contribution,
    });
    return response.data;
  },

  // Contact Form (routed to info@)
  submitContact: async (name, email, message) => {
    const response = await axios.post(`${API}/contact`, {
      name,
      email,
      message,
    });
    return response.data;
  },

  // Generic inquiry (media => media@, etc.)
  submitInquiry: async ({ type, name, email, message }) => {
    const response = await axios.post(`${API}/inquiry`, {
      type,
      name,
      email,
      message,
    });
    return response.data;
  },
};
